import { Reveal } from "./Reveal";
import { TRIM_PRICING } from "@/constants/options";

const formatPrice = (value) => `$${value.toLocaleString("en-US")}`;
const slugify = (value) => value.toLowerCase().replace(/[^a-z0-9]+/g, "-");

export const Pricing = () => (
    <section
        id="pricing"
        data-testid="pricing-section"
        className="border-y border-white/10 bg-[#080808] py-28 sm:py-36"
    >
        <div className="mx-auto max-w-7xl px-6">
            <Reveal className="flex flex-wrap items-end justify-between gap-6">
                <div>
                    <p className="mb-4 flex items-center gap-3 text-xs font-bold uppercase tracking-[0.35em] text-[#2563EB]">
                        <span className="h-2 w-2 rotate-45 bg-[#2563EB]" aria-hidden="true" />
                        Official pricing
                    </p>
                    <h2
                        data-testid="pricing-heading"
                        className="max-w-3xl font-display text-3xl font-extrabold uppercase leading-[1.02] tracking-tighter sm:text-5xl"
                    >
                        Reserve Your 2026 RAV4 TODAY
                    </h2>
                </div>
                <p className="max-w-sm text-base leading-relaxed text-zinc-400 md:text-lg">
                    MSRP and invoice pricing below are shown without the $1,595.00 delivery fee.
                </p>
            </Reveal>

            <Reveal delay={0.12} className="mt-16 border border-white/10 bg-[#050505]">
                <div className="overflow-x-auto">
                    <table
                        data-testid="pricing-table"
                        className="w-full min-w-[820px] border-collapse text-left"
                    >
                        <thead>
                            <tr className="border-b border-white/10 text-xs font-bold uppercase tracking-[0.25em] text-zinc-500">
                                <th className="px-6 py-5">2026 Toyota RAV4 trim</th>
                                <th className="px-6 py-5 text-right">MSRP</th>
                                <th className="px-6 py-5 text-right">Invoice</th>
                            </tr>
                        </thead>
                        <tbody>
                            {TRIM_PRICING.map((row, index) => (
                                <tr
                                    key={`${row.model}-${row.drivetrain}`}
                                    data-testid={`pricing-row-${slugify(`${row.model} ${row.drivetrain}`)}`}
                                    className={`border-b border-white/10 transition-colors duration-300 hover:bg-white/[0.03] ${
                                        index === TRIM_PRICING.length - 1 ? "border-b-0" : ""
                                    }`}
                                >
                                    <td className="px-6 py-5">
                                        <p className="font-display text-lg font-bold uppercase tracking-tight text-white">
                                            2026 Toyota RAV4 — {row.model}
                                        </p>
                                        <p className="mt-1 text-xs font-semibold uppercase tracking-[0.2em] text-zinc-500">
                                            {row.drivetrain}
                                        </p>
                                    </td>
                                    <td
                                        data-testid={`pricing-msrp-${slugify(`${row.model} ${row.drivetrain}`)}`}
                                        className="px-6 py-5 text-right font-display text-xl font-extrabold tracking-tight text-white"
                                    >
                                        {formatPrice(row.msrp)}
                                    </td>
                                    <td
                                        data-testid={`pricing-invoice-${slugify(`${row.model} ${row.drivetrain}`)}`}
                                        className="px-6 py-5 text-right font-display text-xl font-extrabold tracking-tight text-white"
                                    >
                                        {formatPrice(row.invoice)}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                <div
                    data-testid="pricing-delivery-fee-note"
                    className="border-t border-white/10 bg-black/40 px-6 py-5"
                >
                    <p className="text-sm leading-relaxed text-zinc-400 sm:text-base">
                        Please consider the{" "}
                        <span className="font-semibold text-white">$1,595 Delivery Fee</span> as a
                        true dealer cost.
                    </p>
                </div>
            </Reveal>
        </div>
    </section>
);
